import React from "react";

interface DetectNetworkProps {
  children: React.ReactNode;
}

export default function DetectNetwork({ children }: DetectNetworkProps) {

  // Map chain to display format
  // const mapperChain = mapNetworkToIcon(chainId.toString()).toUpperCase();
  // const routerLocal =
  //   config[mapperChain as keyof typeof config] || config.DEFAULT_CASE;

  return (
    <>
      {/* {NetworkWarningDialogComponent} */}
      <div>{children}</div>
    </>
  );
}
